export default __webpack_public_path__ + "static/media/1237.4f1a09ea.png";